import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Accounting module landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it. The route is gated by dept.accounting in allRoutes.js.
 */
const TOOLS = [
    "epoAccounting", "epoReadyPay", "epoNotReady", "epoMpc", "epoFind", "epoFindByItem", "epoMissing",
    "travelAccounting", "epoLimits", "cr", "tasks", "epoCreate",
];
const REPORTS = [
    "xray-report", "aged-receivables-sswhite", "aged-receivables-shukla", "aged-payables", "variance-report",
    "backlog-orders", "open-orders", "inventory-performance",
];

const Accounting = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-bank-line"
                        eyebrow="Finance"
                        title="Accounting"
                        subtitle="Ledger, billing, and financial reporting"
                        tone="default"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Accounting" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Accounting tools"
                        description="EPO payment queues, travel reimbursements and lookups"
                        icon="ri-bank-line"
                    />
                    <DeptReportsGrid ids={REPORTS} />

                    <ComingSoonCard
                        compact
                        icon="ri-bank-line"
                        title="More for Accounting later"
                        message="Ideas for later: invoice and AR/AP tracking and month-end checklists. The cards above are live today."
                        tone="primary"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Accounting;
